import type { RouteConfig } from 'vue-router';
import supplementaryBackgroundImage from '@/assets/img/supplementary/bg-sign.png';

export default [
  /**
   * 委托划扣授权协议补签告知
   */
  {
    path: '/supplementary/deduct-authority-letter',
    meta: {
      excludeLogin: true,
      canBack: false,
      title: '宜享花',
      background: `#f8f9ff url(${supplementaryBackgroundImage}) no-repeat 0 0/100% auto`,
    },
    component: () => import('@/views/supplementary/deduct-authority-letter/index.vue'),
  },
  /**
   * 委托划扣授权协议补签
   */
  {
    path: '/supplementary/deduct-authority-letter/sign',
    meta: {
      title: ' 补签协议',
      background: '#fff',
    },
    component: () => import('@/views/supplementary/deduct-authority-letter/sign.vue'),
  },
  /**
   * 补签协议页面
   * 目前仅用于宜享花补签协议
   */
  {
    path: '/supplement/agreement',
    meta: {
      title: '补签协议',
      canBack: false,
    },
    component: () => import('@/views/supplementary/index.vue'),
  },
  /**
   * 人脸识别准备页
   * 目前用于补签协议流程
   */
  {
    path: '/supplement/face-recognition',
    meta: {
      title: '人脸验证',
      background: '#fff',
      canBack: false,
    },
    component: () => import('@/views/supplementary/face-recognition.vue'),
  },
  /**
   * 人脸识别结果页
   * 目前用于补签协议流程
   */
  {
    path: '/supplement/face-recognition/result',
    meta: {
      title: '人脸验证',
      background: '#fff',
    },
    component: () => import('@/views/supplementary/face-recognition-result.vue'),
  },
  /**
   * 客诉承诺函补签协议
   */
  {
    path: '/supplementary/commitment-letter',
    meta: {
      title: '文件签署',
      background: '#fff',
      canBack: false,
    },
    component: () => import('@/views/supplementary/commitment-letter/sign.vue'),
  },
] as RouteConfig[];
